import { render, staticRenderFns } from "./DVfieldId.vue?vue&type=template&id=5774286a&scoped=true"
import script from "./DVfieldId.vue?vue&type=script&lang=js"
export * from "./DVfieldId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774286a",
  null
  
)

export default component.exports